import { useContext } from "react";
import { Navbar } from "./navbar";
import { AuthContext } from "@/contexts/authContext";

interface ContentLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function ContentLayout({ title, children }: ContentLayoutProps) {
  const { user } = useContext(AuthContext);

  return (
    <div>
      <Navbar title={title} accountBalance={user?.balance != null ? new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "XOF",
      }).format(user?.balance) : ""} />
      <div className="container pt-8 pb-8 px-4 sm:px-8">{children}</div>
    </div>
  );
}
